import {useState} from 'react'
import {createPortal} from 'react-dom'

const CustomerNumberCell = ({
  value,
  status,
  cooper,
}: {
  value: string
  status: string
  cooper: string
}) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    try {
      // ✅ HTTPS or localhost → 최신 API 사용
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value)
      } else {
        // ⚙️ HTTP 환경 fallback → execCommand 사용
        const textarea = document.createElement('textarea')
        textarea.value = value
        textarea.style.position = 'fixed' // iOS 스크롤 방지
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.focus()
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
      }

      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('복사 실패:', err)
    }
  }

  // status 매핑
  const statusLabel: Record<string, string> = {
    as: 'A/S',
    remove: '철거',
    disused: '폐전',
    impossible: '설치불가',
  }

  const cooperLabel = [
    {id: '1', name: '영아이티(주)'},
    {id: '3', name: '두리사업단'},
    {id: '4', name: '케이스마트피아'},
    {id: '5', name: '청호정밀'},
    {id: '6', name: '하이텍앤솔'},
    {id: '8', name: '아이에스테크놀러지'},
    {id: '9', name: '삼원미터텍'},
  ]

  const displayStatus = status ? statusLabel[status] ?? status : ''

  let displayCooper = ''

  if (cooper === '1' || cooper === null) {
    displayCooper = '영아이티(주)'
  } else {
    const found = cooperLabel.find((c) => c.id === cooper)
    displayCooper = found ? found.name : cooper
  }

  return (
    <div className='flex flex-col items-center'>
      <button onClick={handleCopy} className='text-blue-600 font-semibold hover:text-blue-800'>
        {value}
      </button>

      {displayCooper && (
        <div className='text-[14px]'>
          {displayCooper}{' '}
          {displayStatus && <span className='font-bold text-orange-600'>({displayStatus})</span>}
        </div>
      )}

      {/* 포털은 클라이언트 사이드에서만 렌더 */}
      {copied &&
        typeof window !== 'undefined' &&
        createPortal(
          <div className='fixed top-[10%] left-1/2 transform -translate-x-1/2 bg-gray-800 text-white px-4 py-2 rounded-lg shadow-md text-lg z-50'>
            수용가번호 {value}가 복사되었습니다
          </div>,
          document.body
        )}
    </div>
  )
}

export default CustomerNumberCell
